exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-gallery__item {\n  position: relative;\n  display: inline-block;\n  float: left;\n  width: 200px;\n  height: auto;\n  padding: 0 6px;\n  margin-bottom: 12px; }\n\n.image-gallery img {\n  width: 200px;\n  height: auto;\n  padding: 0 6px;\n  -o-object-fit: cover;\n     object-fit: cover;\n  z-index: 1;\n  transition: all .2s; }\n\n.image-gallery__button {\n  position: absolute;\n  top: 0;\n  right: 0;\n  color: #ff0000;\n  z-index: 2; }\n\n.header-image {\n  position: relative;\n  display: inline-block;\n  float: left;\n  width: 100%;\n  height: auto;\n  margin-bottom: 12px; }\n  .header-image img {\n    width: 100%;\n    height: auto;\n    z-index: 1;\n    -o-object-fit: cover;\n       object-fit: cover;\n    transition: all .2s; }\n\n.fa {\n  font-size: 1rem !important; }\n\n.icon-warn {\n  color: #fabb3d; }\n\n.input-group--checkbox {\n  width: 14px;\n  height: 14px;\n  margin: auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/base-data/components/contact-detail/contact-detail.component.scss
// module id = 968
// module chunks = 1